import { render, staticRenderFns } from "./OfficeServeGroup.vue?vue&type=template&id=9e739832&scoped=true&"
import script from "./OfficeServeGroup.vue?vue&type=script&lang=js&"
export * from "./OfficeServeGroup.vue?vue&type=script&lang=js&"
import style0 from "./OfficeServeGroup.vue?vue&type=style&index=0&id=9e739832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e739832",
  null
  
)

export default component.exports